/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const M = globalThis, S = M.trustedTypes, B = S ? S.createPolicy("lit-html", { createHTML: (l) => l }) : void 0, I = "$lit$", d = `lit$${Math.random().toFixed(9).slice(2)}$`, E = "?" + d, X = `<${E}>`, g = document, H = () => g.createComment(""), x = (l) => l === null || typeof l != "object" && typeof l != "function", D = Array.isArray, k = (l) => D(l) || typeof (l == null ? void 0 : l[Symbol.iterator]) == "function", w = `[ 	
\f\r]`, y = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, U = /-->/g, P = />/g, p = RegExp(`>|${w}(?:([^\\s"'>=/]+)(${w}*=${w}*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`, "g"), R = /'/g, L = /"/g, O = /^(?:script|style|textarea|title)$/i, z = (l) => (t, ...e) => ({ _$litType$: l, strings: t, values: e }), Y = z(1), tt = z(2), N = Symbol.for("lit-noChange"), _ = Symbol.for("lit-nothing"), V = /* @__PURE__ */ new WeakMap(), v = g.createTreeWalker(g, 129);
function F(l, t) {
  if (!Array.isArray(l) || !l.hasOwnProperty("raw"))
    throw Error("invalid template strings array");
  return B !== void 0 ? B.createHTML(t) : t;
}
const Z = (l, t) => {
  const e = l.length - 1, s = [];
  let i, o = t === 2 ? "<svg>" : "", n = y;
  for (let r = 0; r < e; r++) {
    const h = l[r];
    let $, A, a = -1, c = 0;
    for (; c < h.length && (n.lastIndex = c, A = n.exec(h), A !== null); )
      c = n.lastIndex, n === y ? A[1] === "!--" ? n = U : A[1] !== void 0 ? n = P : A[2] !== void 0 ? (O.test(A[2]) && (i = RegExp("</" + A[2], "g")), n = p) : A[3] !== void 0 && (n = p) : n === p ? A[0] === ">" ? (n = i != null ? i : y, a = -1) : A[1] === void 0 ? a = -2 : (a = n.lastIndex - A[2].length, $ = A[1], n = A[3] === void 0 ? p : A[3] === '"' ? L : R) : n === L || n === R ? n = p : n === U || n === P ? n = y : (n = p, i = void 0);
    const u = n === p && l[r + 1].startsWith("/>") ? " " : "";
    o += n === y ? h + X : a >= 0 ? (s.push($), h.slice(0, a) + I + h.slice(a) + d + u) : h + d + (a === -2 ? r : u);
  }
  return [F(l, o + (l[e] || "<?>") + (t === 2 ? "</svg>" : "")), s];
};
class T {
  constructor({ strings: t, _$litType$: e }, s) {
    let i;
    this.parts = [];
    let o = 0, n = 0;
    const r = t.length - 1, h = this.parts, [$, A] = Z(t, e);
    if (this.el = T.createElement($, s), v.currentNode = this.el.content, e === 2) {
      const a = this.el.content.firstChild;
      a.replaceWith(...a.childNodes);
    }
    for (; (i = v.nextNode()) !== null && h.length < r; ) {
      if (i.nodeType === 1) {
        if (i.hasAttributes())
          for (const a of i.getAttributeNames())
            if (a.endsWith(I)) {
              const c = A[n++], u = i.getAttribute(a).split(d), b = /([.?@])?(.*)/.exec(c);
              h.push({ type: 1, index: o, name: b[2], strings: u, ctor: b[1] === "." ? G : b[1] === "?" ? J : b[1] === "@" ? K : C }), i.removeAttribute(a);
            } else
              a.startsWith(d) && (h.push({ type: 6, index: o }), i.removeAttribute(a));
        if (O.test(i.tagName)) {
          const a = i.textContent.split(d), c = a.length - 1;
          if (c > 0) {
            i.textContent = S ? S.emptyScript : "";
            for (let u = 0; u < c; u++)
              i.append(a[u], H()), v.nextNode(), h.push({ type: 2, index: ++o });
            i.append(a[c], H());
          }
        }
      } else if (i.nodeType === 8)
        if (i.data === E)
          h.push({ type: 2, index: o });
        else {
          let a = -1;
          for (; (a = i.data.indexOf(d, a + 1)) !== -1; )
            h.push({ type: 7, index: o }), a += d.length - 1;
        }
      o++;
    }
  }
  static createElement(t, e) {
    const s = g.createElement("template");
    return s.innerHTML = t, s;
  }
}
function f(l, t, e = l, s) {
  var i, o, n;
  if (t === N)
    return t;
  let r = s !== void 0 ? (i = e._$Co) == null ? void 0 : i[s] : e._$Cl;
  const h = x(t) ? void 0 : t._$litDirective$;
  return (r == null ? void 0 : r.constructor) !== h && ((o = r == null ? void 0 : r._$AO) == null || o.call(r, !1), h === void 0 ? r = void 0 : (r = new h(l), r._$AT(l, e, s)), s !== void 0 ? ((n = e._$Co) != null ? n : e._$Co = [])[s] = r : e._$Cl = r), r !== void 0 && (t = f(l, r._$AS(l, t.values), r, s)), t;
}
class q {
  constructor(t, e) {
    this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = e;
  }
  get parentNode() {
    return this._$AM.parentNode;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  u(t) {
    var e;
    const { el: { content: s }, parts: i } = this._$AD, o = ((e = t == null ? void 0 : t.creationScope) != null ? e : g).importNode(s, !0);
    v.currentNode = o;
    let n = v.nextNode(), r = 0, h = 0, $ = i[0];
    for (; $ !== void 0; ) {
      if (r === $.index) {
        let A;
        $.type === 2 ? A = new m(n, n.nextSibling, this, t) : $.type === 1 ? A = new $.ctor(n, $.name, $.strings, this, t) : $.type === 6 && (A = new Q(n, this, t)), this._$AV.push(A), $ = i[++h];
      }
      r !== ($ == null ? void 0 : $.index) && (n = v.nextNode(), r++);
    }
    return v.currentNode = g, o;
  }
  p(t) {
    let e = 0;
    for (const s of this._$AV)
      s !== void 0 && (s.strings !== void 0 ? (s._$AI(t, s, e), e += s.strings.length - 2) : s._$AI(t[e])), e++;
  }
}
class m {
  get _$AU() {
    var t, e;
    return (e = (t = this._$AM) == null ? void 0 : t._$AU) != null ? e : this._$Cv;
  }
  constructor(t, e, s, i) {
    var o;
    this.type = 2, this._$AH = _, this._$AN = void 0, this._$AA = t, this._$AB = e, this._$AM = s, this.options = i, this._$Cv = (o = i == null ? void 0 : i.isConnected) != null ? o : !0;
  }
  get parentNode() {
    let t = this._$AA.parentNode;
    const e = this._$AM;
    return e !== void 0 && (t == null ? void 0 : t.nodeType) === 11 && (t = e.parentNode), t;
  }
  get startNode() {
    return this._$AA;
  }
  get endNode() {
    return this._$AB;
  }
  _$AI(t, e = this) {
    t = f(this, t, e), x(t) ? t === _ || t == null || t === "" ? (this._$AH !== _ && this._$AR(), this._$AH = _) : t !== this._$AH && t !== N && this._(t) : t._$litType$ !== void 0 ? this.$(t) : t.nodeType !== void 0 ? this.T(t) : k(t) ? this.k(t) : this._(t);
  }
  S(t) {
    return this._$AA.parentNode.insertBefore(t, this._$AB);
  }
  T(t) {
    this._$AH !== t && (this._$AR(), this._$AH = this.S(t));
  }
  _(t) {
    this._$AH !== _ && x(this._$AH) ? this._$AA.nextSibling.data = t : this.T(g.createTextNode(t)), this._$AH = t;
  }
  $(t) {
    var e;
    const { values: s, _$litType$: i } = t, o = typeof i == "number" ? this._$AC(t) : (i.el === void 0 && (i.el = T.createElement(F(i.h, i.h[0]), this.options)), i);
    if (((e = this._$AH) == null ? void 0 : e._$AD) === o)
      this._$AH.p(s);
    else {
      const n = new q(o, this), r = n.u(this.options);
      n.p(s), this.T(r), this._$AH = n;
    }
  }
  _$AC(t) {
    let e = V.get(t.strings);
    return e === void 0 && V.set(t.strings, e = new T(t)), e;
  }
  k(t) {
    D(this._$AH) || (this._$AH = [], this._$AR());
    const e = this._$AH;
    let s, i = 0;
    for (const o of t)
      i === e.length ? e.push(s = new m(this.S(H()), this.S(H()), this, this.options)) : s = e[i], s._$AI(o), i++;
    i < e.length && (this._$AR(s && s._$AB.nextSibling, i), e.length = i);
  }
  _$AR(t = this._$AA.nextSibling, e) {
    var s;
    for ((s = this._$AP) == null ? void 0 : s.call(this, !1, !0, e); t && t !== this._$AB; ) {
      const i = t.nextSibling;
      t.remove(), t = i;
    }
  }
  setConnected(t) {
    var e;
    this._$AM === void 0 && (this._$Cv = t, (e = this._$AP) == null || e.call(this, t));
  }
}
class C {
  get tagName() {
    return this.element.tagName;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  constructor(t, e, s, i, o) {
    this.type = 1, this._$AH = _, this._$AN = void 0, this.element = t, this.name = e, this._$AM = i, this.options = o, s.length > 2 || s[0] !== "" || s[1] !== "" ? (this._$AH = Array(s.length - 1).fill(new String()), this.strings = s) : this._$AH = _;
  }
  _$AI(t, e = this, s, i) {
    const o = this.strings;
    let n = !1;
    if (o === void 0)
      t = f(this, t, e, 0), n = !x(t) || t !== this._$AH && t !== N, n && (this._$AH = t);
    else {
      const r = t;
      let h, $;
      for (t = o[0], h = 0; h < o.length - 1; h++)
        $ = f(this, r[s + h], e, h), $ === N && ($ = this._$AH[h]), n || (n = !x($) || $ !== this._$AH[h]), $ === _ ? t = _ : t !== _ && (t += ($ != null ? $ : "") + o[h + 1]), this._$AH[h] = $;
    }
    n && !i && this.j(t);
  }
  j(t) {
    t === _ ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t != null ? t : "");
  }
}
class G extends C {
  constructor() {
    super(...arguments), this.type = 3;
  }
  j(t) {
    this.element[this.name] = t === _ ? void 0 : t;
  }
}
class J extends C {
  constructor() {
    super(...arguments), this.type = 4;
  }
  j(t) {
    this.element.toggleAttribute(this.name, !!t && t !== _);
  }
}
class K extends C {
  constructor(t, e, s, i, o) {
    super(t, e, s, i, o), this.type = 5;
  }
  _$AI(t, e = this) {
    var s;
    if ((t = (s = f(this, t, e, 0)) != null ? s : _) === N)
      return;
    const i = this._$AH, o = t === _ && i !== _ || t.capture !== i.capture || t.once !== i.once || t.passive !== i.passive, n = t !== _ && (i === _ || o);
    o && this.element.removeEventListener(this.name, this, i), n && this.element.addEventListener(this.name, this, t), this._$AH = t;
  }
  handleEvent(t) {
    var e, s;
    typeof this._$AH == "function" ? this._$AH.call((s = (e = this.options) == null ? void 0 : e.host) != null ? s : this.element, t) : this._$AH.handleEvent(t);
  }
}
class Q {
  constructor(t, e, s) {
    this.element = t, this.type = 6, this._$AN = void 0, this._$AM = e, this.options = s;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(t) {
    f(this, t);
  }
}
const et = { P: I, A: d, C: E, M: 1, L: Z, R: q, D: k, V: f, I: m, H: C, N: J, U: K, B: G, F: Q }, W = M.litHtmlPolyfillSupport;
var j;
W == null || W(T, m), ((j = M.litHtmlVersions) != null ? j : M.litHtmlVersions = []).push("3.1.3");
const it = (l, t, e) => {
  var s, i;
  const o = (s = e == null ? void 0 : e.renderBefore) != null ? s : t;
  let n = o._$litPart$;
  if (n === void 0) {
    const r = (i = e == null ? void 0 : e.renderBefore) != null ? i : null;
    o._$litPart$ = n = new m(t.insertBefore(H(), r), r, void 0, e != null ? e : {});
  }
  return n._$AI(l), n;
};
export {
  et as _$LH,
  Y as html,
  N as noChange,
  _ as nothing,
  it as render,
  tt as svg
};
